import React, { useState } from "react";
import TopNavBar from "./TopNavBar";
import Sidebar from "./Sidebar";
import SubNavigationBar from "./SubNavigationBar";
import "../styles/AppLayout.css";

function AppLayout({ children }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const role = localStorage.getItem("userRole");
  const isAdmin = role === "1" || user?.role === "admin";

  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <TopNavBar onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      {isAdmin && <SubNavigationBar sidebarOpen={sidebarOpen} user={user} />}

      <div style={{ display: "flex" }}>
        {isAdmin && <Sidebar isOpen={sidebarOpen} />}
        <div
          className="app-layout-content"
          style={{
            marginLeft: isAdmin && sidebarOpen ? "180px" : "0px",
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
}

export default AppLayout;
